import styled, { css } from 'styled-components';
import mixins from '../../../styles/mixins';
import COLORS from '../../../constants/COLORS';
import Button from '../Button';
import { rgba } from 'polished';

export const Container = styled.div<{ fluid: boolean; noCalendarIcon: boolean }>`
  position: relative;
  padding-left: ${({ noCalendarIcon }) => (noCalendarIcon ? '20px' : '78px')};

  ${({ theme: { isMobile, withAnnouncements } }) =>
    !isMobile &&
    css`
      .slick-list,
      .slick-track {
        position: relative;
        display: flex;
      }

      .slick-track {
        width: auto !important;
      }
      .slick-loading .slick-slide,
      .slick-loading .slick-track {
        visibility: hidden;
      }
      .slick-slider {
        display: flex;
        max-width: 350px;
        overflow: hidden;
        box-sizing: border-box;
        user-select: none;
        touch-action: pan-y;

        @media screen and (min-width: 768px) and (max-width: 880px) {
          max-width: 300px;
        }

        @media screen and (min-width: 1100px) {
          max-width: ${withAnnouncements ? '350px' : '540px'};
        }

        @media screen and (min-width: 1215px) {
          max-width: ${withAnnouncements && '530px'};
        }

        @media screen and (min-width: 1300px) {
          max-width: ${withAnnouncements ? '540px' : '800px'};
        }
      }
      .slick-list {
        overflow: hidden;
        margin: 0;
        padding: 0;
      }
      .slick-list:focus {
        outline: 0;
      }
      .slick-list.dragging {
        cursor: pointer;
        cursor: hand;
      }
      .slick-slider .slick-list,
      .slick-slider .slick-track {
        transform: translate3d(0, 0, 0);
      }
      .slick-track {
        top: 0;
        left: 0;
      }
      .slick-track:after,
      .slick-track:before {
        display: table;
        content: '';
      }
      .slick-track:after {
        clear: both;
      }
      .slick-slide {
        display: none;
        float: left;
        height: 100%;
        min-height: 1px;
      }
      [dir='rtl'] .slick-slide {
        float: right;
      }
      .slick-slide img {
        display: block;
      }
      .slick-slide.slick-loading img {
        display: none;
      }
      .slick-slide.dragging img {
        pointer-events: none;
      }
      .slick-initialized .slick-slide {
        display: block;
      }
      .slick-vertical .slick-slide {
        display: block;
        height: auto;
        border: 1px solid transparent;
      }
      .slick-arrow.slick-hidden {
        display: none;
      }

      .slick-loading .slick-list {
        background: url(ajax-loader.gif) center center no-repeat #fff;
      }
      .slick-next,
      .slick-prev {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        padding: 0;
        border: none;
        background-color: transparent;
        cursor: pointer;
        margin-top: 5px;

        @media screen and (min-width: 768px) and (max-width: 880px) {
          width: 38px;
        }
      }
      .slick-disabled {
        cursor: default;

        svg path {
          stroke: ${COLORS.GREY_B4};
        }
      }
    `}
  ${(props) =>
    props.theme.isMobile
      ? css`
          overflow: hidden;
          margin-top: 12px;
        `
      : css`
          display: flex;
          justify-content: center;
          padding: 0 24px 0 100px;
          margin-top: 20px;
        `}
    ${(props) =>
    props.theme.withAnnouncements &&
    !props.theme.isMobile &&
    css`
      /* padding: 20px 0; */
      margin-right: 60px;
      /* justify-content: flex-start; */
    `};
`;

export const ScrollMenu = styled.div`
  ${mixins.hideScrollBar}

  position: relative;
  display: flex;
  align-items: center;
  padding: 0 16px 0 0;
  overflow-x: auto;
  cursor: grab;
  z-index: 99;
`;

export const MenuItem = styled.div<{
  selected?: boolean;
  onClick?: any;
  ref?: any;
  calendar?: boolean;
  isLines?: boolean;
}>`
  position: relative;
  flex-grow: 1;
  padding: 8px 16px;
  margin: 0 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
  border-radius: 8px;
  border: ${({ selected }) => {
    if (selected) {
      return null;
    }

    return `1px solid ${rgba(COLORS.MARKETPLACE_BLACK, 0.1)}`;
  }};
  background-color: ${({ selected, theme }) => {
    if (selected) {
      return theme.buttonBackground;
    }

    return '#fff';
  }};
  color: ${({ selected }) => {
    if (selected) {
      return '#fff';
    }

    return '#000';
  }};

  ${({ calendar }) =>
    calendar &&
    css`
      display: flex;
      align-items: center;
      padding: 0 14px;
      white-space: normal;
      font-size: 12px;
      line-height: 16px;
      height: 48px;
    `}

  &:hover {
    cursor: pointer;
    background-color: ${({ selected, theme }) =>
      selected ? theme.buttonBackground : rgba(theme.buttonBackground, 0.2)};
  }

  &:first-child {
    margin-left: 0;
  }

  ${({ isLines }) => {
    if (isLines) {
      return css`
        position: relative;
        padding: 4px 16px 4px 24px;

        ${TicketsStatus} {
          position: absolute;
          height: calc(100% - 16px);
          width: 2px;
          top: 8px;
          left: 16px;
          border: 0;
          border-radius: 2px;
        }
      `;
    }
  }}

  ${({ theme: { isMobile } }) =>
    isMobile &&
    css`
      padding-top: 4px;
      padding-bottom: 4px;
    `}
`;

export const MenuItemDate = styled.span`
  display: inline-block;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const MenuItemStatus = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
`;

export const DatepickerButtonWithAnnouncements = styled.div`
  position: absolute;
  padding: 4px 20px;

  z-index: 99;

  ${({ theme: { isMobile, isRtl, withAnnouncements } }) =>
    !isMobile &&
    !withAnnouncements &&
    css`
      position: absolute;
      top: 20px;
      right: 24px;
      padding: 0;
      z-index: 99;

      button {
        padding: 12px 18px 12px 23px;
      }

      .arrow-icon {
        margin: ${isRtl ? '0 20px 0 0' : '0 0 0 20px'};
      }
    `}
  ${({ theme: { isMobile, withAnnouncements } }) =>
    !isMobile &&
    withAnnouncements &&
    css`
      position: absolute;
      top: 21px;
      right: -34px;
      padding: 0;
      z-index: 99;

      button {
        padding: 12px 18px;
      }
    `}
`;

export const DatepickerButtonContainer = styled.div`
  z-index: 99;
  top: 0;
  margin-top: 5px;

  button {
    font-weight: 600;
  }

  ${({ theme: { isMobile } }) =>
    isMobile
      ? css`
          position: absolute;
          width: 50px;
          height: 100%;
          left: 20px;
          margin-top: 0;

          button {
            height: 100%;
          }
        `
      : css`
          height: 100%;
          width: auto;
          right: 48px;
          white-space: nowrap;

          button {
            display: flex;
            padding: 12px 18px;
          }

          svg {
            margin-right: 10px;
          }
        `}
`;

export const DatepickerText = styled.span`
  display: inline-block;
  color: #000;

  ${({ theme: { isMobile } }) =>
    isMobile &&
    css`
      display: none;
    `}
`;

export const DatepickerButton = styled(Button)`
  background-color: ${COLORS.WHITE};
  border: 1px solid ${rgba(COLORS.MARKETPLACE_BLACK, 0.1)};
`;

const TicketsStatus = styled.span`
  width: 12px;
  height: 12px;
  margin-right: 8px;
  display: inline-block;
  border: 2px solid ${COLORS.WHITE};
  border-radius: 100%;
`;

export const DateHasTickets = styled(TicketsStatus)`
  background-color: ${COLORS.GREEN};
`;

export const DateNoTickets = styled(TicketsStatus)`
  background-color: ${COLORS.GREY_D9};
`;
